import ScrollMagic from 'scrollmagic';

$(() => {

    const controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
        triggerElement: '.l-page__header',
        offset: 50,
        reverse: false,
    })
    .setClassToggle('.l-page__header .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__solutions-features--mobilecommerce',
        triggerHook: 0.95,
        reverse: false,
    })
    .setClassToggle('.l-page__solutions-features--mobilecommerce .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__section--mobile-commerce-work',
        triggerHook: 0.8,
        reverse: false,
    })
    .setClassToggle('.l-page__section--mobile-commerce-work .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__mobile-commerce-capabilities',
        triggerHook: 0.8,
        reverse: false,
    })
    .setClassToggle('.l-page__mobile-commerce-capabilities .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__connect',
        triggerHook: 0.8,
        reverse: false,
    })
    .setClassToggle('.l-page__connect .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__get-now',
        triggerHook: 0.8,
        reverse: false,
    })
    .setClassToggle('.l-page__get-now .js-animate', 'js-animate-loaded')
    .addTo(controller);

});



// WEBPACK FOOTER //
// ./app/scripts/pages/solutions/mobile-commerce.js